export const MultiSelect = (props) => {
    const {
        selections,
        options,
        removeSelection,
        addSelection,
        name,
        onChange,
        value,
        isActive,
        setActive,
        readOnly,
    } = props;

    return (
        <div className="w-full flex flex-col mx-auto">
            {name && (
                <label className="mr-2 text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">
                    {name}
                </label>
            )}
            <div className="w-full">
                <div className="flex flex-col items-center relative">
                    <div className="w-full">
                        <div
                            onClick={() => setActive && setActive(!isActive)}
                            className={
                                readOnly
                                    ? "p-1 flex border border-gray-200 rounded-sm bg-gray-200"
                                    : " p-1 flex border border-gray-200 rounded-sm"
                            }
                        >
                            <div className="flex flex-auto flex-wrap">
                                {selections.map((selected) => {
                                    return (
                                        <div
                                            key={selected.label}
                                            className="flex justify-center items-center m-1 font-medium py-1 px-2 rounded-full text-teal-700 bg-teal-100 border border-teal-300 "
                                        >
                                            <div className="text-xs font-normal leading-none max-w-full flex-initial">
                                                {selected.label}
                                            </div>
                                            <div className="flex flex-auto flex-row-reverse">
                                                <div
                                                    onClick={() => {
                                                        if (!readOnly) {
                                                            removeSelection(
                                                                selected
                                                            );
                                                        }
                                                    }}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="100%"
                                                        height="100%"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="feather feather-x cursor-pointer hover:text-teal-400 rounded-full w-4 h-4 ml-2"
                                                    >
                                                        <line
                                                            x1="18"
                                                            y1="6"
                                                            x2="6"
                                                            y2="18"
                                                        ></line>
                                                        <line
                                                            x1="6"
                                                            y1="6"
                                                            x2="18"
                                                            y2="18"
                                                        ></line>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div className="flex-1">
                                    <input
                                        onClick={() =>
                                            setActive && setActive(!isActive)
                                        }
                                        onChange={onChange}
                                        defaultValue={value}
                                        className="bg-transparent p-1 px-2 appearance-none outline-hidden h-full w-full text-gray-800"
                                    />
                                </div>
                            </div>
                            <div className="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200">
                                <button className="cursor-pointer w-6 h-6 text-gray-600 outline-hidden focus:outline-hidden">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="100%"
                                        height="100%"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-chevron-up w-4 h-4"
                                    >
                                        <polyline points="18 15 12 9 6 15"></polyline>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="absolute shadow-sm top-full bg-white z-40 w-full lef-0 rounded-sm max-h-select overflow-y-auto">
                        {isActive && (
                            <div className="flex flex-col w-full max-h-52">
                                {options.map((option) => {
                                    return (
                                        <div
                                            id={option.label}
                                            onClick={() => {
                                                if (!readOnly) {
                                                    addSelection(option);
                                                }
                                            }}
                                            className="cursor-pointer w-full border-gray-100 rounded-t border-b hover:bg-teal-100"
                                        >
                                            <div className="flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative hover:border-teal-100">
                                                <div className="w-full items-center flex">
                                                    <div className="mx-2 leading-6">
                                                        {option.label}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
